import client from "@/api_client/client";
import { ICalendar } from "@/types/ICalendar";
import { IListCalendarResponse } from "@/types/apiClient/IListCalendarsResponse";

interface IGetArgs {
	id: string;
}

function get(args: IGetArgs) {
	return client.get<ICalendar>(`/calendars/${args.id}`).then(res => res.data);
}

function list() {
	return client.get<IListCalendarResponse>('/calendars').then(res => res.data);
}

type ICreateArgs = Pick<ICalendar, 'id' | 'name'> & Partial<ICalendar>;

function create(args: ICreateArgs) {
	return client.put(`/calendars/${args.id}`, { ...args }).then(res => res.data);
}

interface IRemoveArgs {
	id: string;
}

function remove(args: IRemoveArgs) {
	return client.delete<ICalendar>(`/calendars/${args.id}`).then(res => res.data);
}



export default { get, list, create, remove }
